import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LazyComponentWithSuspense } from '../components/LazyLoader';
import PrivateRoute from './PrivateRoute';

// Lazy load all document management components
const DocManagement = LazyComponentWithSuspense(() => import('../Container/DocManagementContainer'));
const FolderById = LazyComponentWithSuspense(() => import('../Container/FolderBy/FolderByIdContainer'));
const PageNotFound = LazyComponentWithSuspense(() => import('../pages/PageNotFound/PageNotFound'));

export const DocManagementRoutes = () => {
  return (
    <Routes>
      <Route path="/file" element={<DocManagement />} />
      <Route path="/file/:id" element={<FolderById />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
